import { IMPSConfig } from '@zeta-types';
import { create } from 'zustand';
import { IMPSConfigStore } from './types';

export const useMPSConfigStore = create<IMPSConfigStore>((set) => ({
  mpsConfigDetails: {} as IMPSConfig,
  status: false,
  updateMPSConfigDetails: (x: IMPSConfig, status: boolean) => set(() => ({ mpsConfigDetails: x, status: status })),
}));

export default useMPSConfigStore;
